(function() {
  function getClosestCardIndex(cards, carousel) {
    if (!cards.length) return 0;

    var carouselRect = carousel.getBoundingClientRect();
    var center = carouselRect.left + carouselRect.width / 2;
    var bestIndex = 0;
    var bestDistance = Infinity;

    cards.forEach(function(card, index) {
      var rect = card.getBoundingClientRect();
      var cardCenter = rect.left + rect.width / 2;
      var distance = Math.abs(cardCenter - center);

      if (distance < bestDistance) {
        bestDistance = distance;
        bestIndex = index;
      }
    });

    return bestIndex;
  }

  function setupFindYourFit(section) {
    var viewport = section.querySelector("[data-fit-viewport]");
    var carousel = section.querySelector("[data-fit-carousel]");
    var cards = Array.from(section.querySelectorAll("[data-fit-card]"));
    var paginationDots = Array.from(section.querySelectorAll("[data-fit-pagination-dot]"));
    var prevButton = section.querySelector("[data-fit-prev]");
    var nextButton = section.querySelector("[data-fit-next]");
    var focusOnMoveEnabled = section.dataset.focusOnMove === "true";
    var initialActiveCardRaw = section.dataset.initialActiveCard;

    if (!viewport || !carousel || cards.length === 0) return;

    var activeIndex = 0;
    var ticking = false;
    var sectionInView = false;
    var observer = null;
    var resizeTimer = null;
    var stabilizeTimer = null;
    var focusTimer = null;
    var wasSectionInView = false;

    function updatePagination(index) {
      if (!paginationDots.length) return;
      paginationDots.forEach(function(dot, dotIndex) {
        dot.setAttribute("aria-current", dotIndex === index ? "true" : "false");
      });
    }

    function updateDesktopArrows(index) {
      if (prevButton) prevButton.disabled = index <= 0;
      if (nextButton) nextButton.disabled = index >= cards.length - 1;
    }

    function pauseAndReset(video) {
      video.pause();
      try {
        video.currentTime = 0;
      } catch (error) {
        // Ignore seek errors before metadata is ready.
      }
    }

    function updateVideoStates() {
      cards.forEach(function(card, index) {
        var video = card.querySelector("[data-fit-video]");
        if (!video) return;

        if (!sectionInView || index !== activeIndex) {
          pauseAndReset(video);
          return;
        }

        var promise = video.play();
        if (promise && typeof promise.catch === "function") {
          promise.catch(function() {});
        }
      });
    }

    function setActive(index) {
      activeIndex = Math.max(0, Math.min(cards.length - 1, index));
      cards.forEach(function(card, cardIndex) {
        var distance = cardIndex - activeIndex;
        var absDistance = Math.abs(distance);

        card.style.setProperty("--fit-direction", distance < 0 ? "-1" : "1");
        card.classList.toggle("is-active", distance === 0);
        card.classList.toggle("is-neighbor", absDistance === 1);
        card.classList.toggle("is-far", absDistance >= 2);
      });
      updatePagination(activeIndex);
      updateDesktopArrows(activeIndex);
      updateVideoStates();
    }

    /**
     * Center `target` in the carousel. Uses scrollLeft + (visual delta from rects) so
     * alignment matches painted layout; offsetLeft alone is unreliable with grid + snap on iOS.
     */
    function getTargetScrollLeft(target) {
      var carouselRect = carousel.getBoundingClientRect();
      var targetRect = target.getBoundingClientRect();
      var targetCenter = targetRect.left + targetRect.width / 2;
      var viewportCenter = carouselRect.left + carouselRect.width / 2;
      var delta = targetCenter - viewportCenter;
      var nextScrollLeft = carousel.scrollLeft + delta;
      var maxScroll = Math.max(0, carousel.scrollWidth - carousel.clientWidth);
      return Math.max(0, Math.min(maxScroll, Math.round(nextScrollLeft)));
    }

    function scrollToIndex(index) {
      var target = cards[index];
      if (!target) return;
      if (focusOnMoveEnabled) {
        window.clearTimeout(focusTimer);
        focusTimer = window.setTimeout(function() {
          viewport.scrollIntoView({ behavior: "smooth", block: "center", inline: "nearest" });
        }, 0);
      }
      carousel.scrollTo({ left: getTargetScrollLeft(target), behavior: "smooth" });
    }

    function jumpToIndex(index) {
      var target = cards[index];
      if (!target) return;
      carousel.scrollTo({ left: getTargetScrollLeft(target), behavior: "auto" });
    }

    function syncScrollToClosestCard() {
      var idx = getClosestCardIndex(cards, carousel);
      var target = cards[idx];
      if (!target) return;
      var desired = getTargetScrollLeft(target);
      setActive(idx);
      if (Math.abs(carousel.scrollLeft - desired) > 0.5) {
        carousel.scrollTo({ left: desired, behavior: "auto" });
      }
    }

    function stabilizeViewportHeight() {
      if (!viewport || !cards.length) return;
      var maxHeight = 0;
      section.classList.add("is-measuring");
      viewport.offsetHeight;

      cards.forEach(function(card) {
        var cardHeight = card.getBoundingClientRect().height;
        if (cardHeight > maxHeight) {
          maxHeight = cardHeight;
        }
      });

      section.classList.remove("is-measuring");
      viewport.style.height = Math.ceil(maxHeight) + "px";
    }

    function scheduleStabilize() {
      window.clearTimeout(stabilizeTimer);
      stabilizeTimer = window.setTimeout(function() {
        stabilizeViewportHeight();
      }, 50);
    }

    function triggerNudgeAnimation() {
      carousel.classList.remove("is-nudging");
      // Force reflow so the class re-add retriggers keyframes.
      carousel.offsetWidth;
      carousel.classList.add("is-nudging");
      window.setTimeout(function() {
        carousel.classList.remove("is-nudging");
      }, 1300);
    }

    function handleSectionVisibility(visible) {
      sectionInView = visible;
      updateVideoStates();

      if (visible && !wasSectionInView) {
        triggerNudgeAnimation();
      }

      wasSectionInView = visible;
    }

    if ("IntersectionObserver" in window) {
      observer = new IntersectionObserver(
        function(entries) {
          entries.forEach(function(entry) {
            if (entry.target === section) {
              handleSectionVisibility(entry.isIntersecting && entry.intersectionRatio > 0.35);
            }
          });
        },
        {
          threshold: [0, 0.35, 0.6, 1]
        }
      );
      observer.observe(section);
    } else {
      // Fallback for very old browsers.
      handleSectionVisibility(true);
    }

    carousel.addEventListener(
      "scroll",
      function() {
        if (ticking) return;
        ticking = true;

        window.requestAnimationFrame(function() {
          ticking = false;
          var nextIndex = getClosestCardIndex(cards, carousel);
          if (nextIndex !== activeIndex) {
            if (focusOnMoveEnabled) {
              window.clearTimeout(focusTimer);
              focusTimer = window.setTimeout(function() {
                viewport.scrollIntoView({ behavior: "smooth", block: "center", inline: "nearest" });
              }, 0);
            }
            setActive(nextIndex);
          }
        });
      },
      { passive: true }
    );

    // iOS Safari often lands a few px off snap after momentum; scrollend + rect-based snap fixes it.
    var supportsScrollEnd = false;
    try {
      supportsScrollEnd = "onscrollend" in document.createElement("div");
    } catch (e) {
      supportsScrollEnd = false;
    }

    if (supportsScrollEnd) {
      carousel.addEventListener("scrollend", syncScrollToClosestCard);
    } else {
      var scrollEndTimer;
      carousel.addEventListener(
        "scroll",
        function() {
          window.clearTimeout(scrollEndTimer);
          scrollEndTimer = window.setTimeout(syncScrollToClosestCard, 120);
        },
        { passive: true }
      );
    }

    if (prevButton) {
      prevButton.addEventListener("click", function() {
        scrollToIndex(Math.max(0, activeIndex - 1));
      });
    }

    if (nextButton) {
      nextButton.addEventListener("click", function() {
        scrollToIndex(Math.min(cards.length - 1, activeIndex + 1));
      });
    }

    if (paginationDots.length) {
      paginationDots.forEach(function(dot) {
        dot.addEventListener("click", function() {
          var targetIndex = parseInt(dot.getAttribute("data-fit-target-index"), 10);
          if (Number.isNaN(targetIndex)) return;
          scrollToIndex(Math.max(0, Math.min(cards.length - 1, targetIndex)));
        });
      });
    }

    window.addEventListener("resize", function() {
      window.clearTimeout(resizeTimer);
      resizeTimer = window.setTimeout(function() {
        stabilizeViewportHeight();
      }, 120);
    });

    cards.forEach(function(card) {
      var image = card.querySelector(".find-your-fit__image");
      var video = card.querySelector(".find-your-fit__video");

      if (image && !image.complete) {
        image.addEventListener("load", scheduleStabilize, { once: true });
      }

      if (video) {
        video.addEventListener("loadedmetadata", scheduleStabilize, { once: true });
        video.addEventListener("loadeddata", scheduleStabilize, { once: true });
      }
    });

    // Initial nudge animation (and retriggers when section re-enters viewport).
    window.requestAnimationFrame(function() {
      triggerNudgeAnimation();
    });

    document.addEventListener("visibilitychange", function() {
      if (document.hidden) {
        handleSectionVisibility(false);
      }
    });

    var initialIndex = 0;
    var parsedInitialCard = parseInt(initialActiveCardRaw, 10);

    if (!Number.isNaN(parsedInitialCard)) {
      // Theme setting is 1-based; convert to zero-based index.
      initialIndex = parsedInitialCard - 1;
    } else if (initialActiveCardRaw === "middle") {
      // Backward compatibility for any previously saved select values.
      initialIndex = Math.floor(cards.length / 2);
    } else if (initialActiveCardRaw === "last") {
      initialIndex = cards.length - 1;
    }

    initialIndex = Math.max(0, Math.min(cards.length - 1, initialIndex));
    setActive(initialIndex);
    jumpToIndex(initialIndex);
    stabilizeViewportHeight();
  }

  function init() {
    var sections = document.querySelectorAll("[data-find-your-fit]");
    sections.forEach(setupFindYourFit);
  }

  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", init);
  } else {
    init();
  }
})();
